import React, { useState } from 'react';

// ─── Ícones SVG disponíveis ───────────────────────────────────────────────────
const ICONES = {

  // Alterar / editar
  alterar: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <path d="M11.5 2.5l2 2L5 13H3v-2L11.5 2.5z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // Visualizar
  visualizar: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <ellipse cx="8" cy="8" rx="6" ry="4" stroke="currentColor" strokeWidth="1.4"/>
      <circle cx="8" cy="8" r="1.8" fill="currentColor"/>
    </svg>
  ),

  // Bloquear
  bloquear: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M5 7V5a3 3 0 016 0v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),

  // Desbloquear / ativar
  desbloquear: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M5 7V5a3 3 0 016 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M11 5h2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    </svg>
  ),

  // Resetar / chave de senha
  senha: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <circle cx="6" cy="9" r="3.5" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M8.5 6.5L13 2M11 2h2v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // Excluir
  excluir: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <path d="M3 4h10M6 4V3h4v1M5 4l.5 8h5L11 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // Incluir / adicionar
  incluir: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  ),

  // Permissões / chave
  permissoes: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <circle cx="5.5" cy="10.5" r="3" stroke="currentColor" strokeWidth="1.4"/>
      <path d="M7.5 8.5l5-5M11 3h2v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="5.5" cy="10.5" r="1" fill="currentColor"/>
    </svg>
  ),

  // Recarregar
  recarregar: (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
      <path d="M13 8A5 5 0 113 8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M13 4v4h-4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};

// ─── Componente BtnIcone ──────────────────────────────────────────────────────
// Padrão para todos os botões de ação nos browses do portal
//
// Props:
//   icone    — string: chave do objeto ICONES acima (ex: 'alterar', 'bloquear')
//   onClick  — função chamada ao clicar
//   title    — tooltip que aparece ao passar o mouse
//   cor      — cor do ícone e da borda (default: cinza neutro)
//   corBg    — cor de fundo ao passar o mouse (default: versão clara da cor)
//   disabled — desabilita o botão
//
// Uso:
//   <BtnIcone icone="alterar"  onClick={() => abrirEditar(u)}  title="Alterar"  />
//   <BtnIcone icone="bloquear" onClick={() => bloquear(u)}     title="Bloquear" cor="#e53935" />
//   <BtnIcone icone="senha"    onClick={() => resetarSenha(u)} title="Resetar senha" cor="#d97706" />

// Props:
//   solido  — fundo colorido permanente (usado no botão Incluir do browse)
//   tamanho — 'normal' (30×30 default) | 'grande' (36×36 — alinha com input height 36)
function BtnIcone({ icone, onClick, title, cor, corBg, disabled, solido, tamanho = 'normal' }) {
  const [hover, setHover] = useState(false);

  const corFinal   = cor   || '#888';
  const corBgFinal = corBg || `${corFinal}18`;

  // Modo sólido: fundo sempre colorido, ícone branco
  const bgFinal = solido
    ? (hover ? `${corFinal}dd` : corFinal)
    : (hover && !disabled ? corBgFinal : 'transparent');

  const bordaFinal = solido
    ? corFinal
    : (hover && !disabled ? corFinal : '#e8eaed');

  const iconeCor = solido ? '#fff' : corFinal;

  // r114: tamanho 'grande' = 36px (alinha com altura do input padrão)
  const dim = tamanho === 'grande' ? '36px' : '30px';

  return (
    <button
      onClick={onClick}
      title={title}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: dim,
        height: dim,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${bordaFinal}`,
        borderRadius: '5px',
        backgroundColor: bgFinal,
        color: iconeCor,
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        transition: 'border-color 0.15s, background-color 0.15s',
        flexShrink: 0,
      }}
    >
      {ICONES[icone] || icone}
    </button>
  );
}

export default BtnIcone;
export { ICONES };
